export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8250.dd8c8289.jpg";